import styled from 'styled-components';
import { tokens } from 'styles/tokens';

const WarningContainer = styled.div`
    color: ${tokens.error.default};
`;

export function WarningText({
    text = 'This action cannot be undone.',
}: {
    /**
     * The text for the warning (defaults to 'This action cannot be undone.').
     */
    text?: string;
}) {
    return (
        <WarningContainer className="py-10" data-cy="delete-component-modal-content">
            <span className="warning-text bold">Warning! </span>
            <span className="warning-text bold"> {text} </span>
        </WarningContainer>
    );
}
